import React from "react";
import { Outlet } from "react-router-dom";
import TopNavbar from "./TopNavbar";

const Layout = () => {
  return (
    <div className="min-h-screen font-sans text-left bg-[#fff9f9] text-[#5c2f2f]">
      <TopNavbar />
      <main className="pt-[100px]">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
